import { useDispatch } from 'react-redux';
import { GestureOutlined } from '@material-ui/icons';
import { Button, Dialog, Grow, Box, DialogTitle, DialogActions, DialogContent, Card } from '@material-ui/core';
import { Actions as Map } from '../../../store/ducks/map';
import { createPortal } from 'react-dom';
/**
 *
 * @function DrawBaselineStep
 * @returns {JSX.Element} Coastline Analysis steps JSX element
 */
const DrawBaselineStep = ({
  t,
  onNext,
  isCurrent,
  handleDrawBaseline,
  handleRedo,
  confirmDrawing,
  setConfirmDrawing,
  readBaselineFileData,
  overlayTarget,
}) => {
  const dispatch = useDispatch();
  return (
    <>
      <Grow in={confirmDrawing} unmountOnExit>
        <Box position="absolute" marginTop={6} paddingTop={2} justifyContent="center" width="100%" zIndex={99}>
          <Dialog
            open={confirmDrawing}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
            PaperProps={{
              style: { padding: 20, borderRadius: 12, textAlign: 'center' },
            }}>
            <DialogTitle id="confirm-dialog-title" style={{ textAlign: 'center' }}>
              {t('forms.csqueeze.result.confirmBaseline')}
            </DialogTitle>
            <DialogContent style={{ fontSize: '16px' }}>
              <p>{t('forms.csqueeze.result.confirmBaseline')}</p>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Button onClick={handleRedo} color="primary">
                {t('forms.csqueeze.result.redo')}
              </Button>
              <Button
                onClick={() => {
                  dispatch(Map.completeDrawing());
                  setConfirmDrawing(false);
                  onNext();
                }}
                color="primary"
                autoFocus>
                {t('forms.csqueeze.result.confirm')}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Grow>
      <Button
        style={{ justifyContent: 'left' }}
        disabled={!isCurrent}
        color="primary"
        startIcon={<GestureOutlined />}
        onClick={handleDrawBaseline}>
        {t('forms.csqueeze.result.drawBaseline')}
      </Button>
      {isCurrent &&
        !confirmDrawing &&
        overlayTarget.current &&
        createPortal(
          <Card
            style={{
              width: '100%',
              padding: 12,
              textAlign: 'center',
              fontSize: 13,
            }}
            elevation={3}>
            {t('forms.csqueeze.result.tipBaseline')}
            {'\n'}
            <Button color="secondary" component="label" htmlFor="file_import_baseline_kml">
              {t('forms.shorelineAnalysis.transectsSettings.importBaseline')}
              <input
                style={{ display: 'none' }}
                id="file_import_baseline_kml"
                accept=".kml"
                type="file"
                onClick={(e) => (e.target.value = null)}
                onChange={readBaselineFileData}
              />
            </Button>
          </Card>,
          overlayTarget.current,
        )}
    </>
  );
};

export default DrawBaselineStep;
